export default "__VITE_ASSET__0Y3nx073__"